import { AfterViewInit, Component, Inject } from '@angular/core';
import { DOCUMENT, NgClass } from '@angular/common';

import { MenuOverlayRef } from '@core/services/menu_filter/menu-overlay-ref';
import { MENU_DIALOG_DATA, OVERLAY_REF, OVERLAY } from '@core/services/menu_filter/menu-overlay-data.tokens';
import { StorageService } from '@core/services/util/storage.service';

import { environment } from '@environment';
import { CategoryFilterPipe } from '@shared/pipes/category-filter.pipe';

@Component({
    selector: 'app-menu-filter',
    templateUrl: './menu-filter.component.html',
    styleUrls: ['./menu-filter.component.scss'],
    standalone: true,
    imports: [NgClass, CategoryFilterPipe]
})
export class MenuFilterComponent implements AfterViewInit {
    private readonly HEADER_OFFSET = 60;

    selectedId: number;
    categories: any;
    categoryCount: any;
    primaryBrandId: number = environment.brand.id;

    constructor(
        public dialogRef: MenuOverlayRef,
        @Inject(MENU_DIALOG_DATA) public menuData: any,
        @Inject(OVERLAY_REF) public overlayRef: any,
        @Inject(DOCUMENT) private document: any,
        @Inject(OVERLAY) private overlay: any,
        private storageService: StorageService
    ) {
        this.selectedId = Number(this.menuData.data.selectCategoryId);
        this.categories = this.menuData.data.categories;
        this.categoryCount = this.menuData.data.categoryCount;
    }

    selectCategory(categoryId) {
        const selectedCategoryID = String(categoryId);
        this.storageService.set('category_id', selectedCategoryID);

        document.body.style.position = '';

        const categorySection = this.document.getElementById(`category-${selectedCategoryID}`);
        if (categorySection) {
            const elementTop = categorySection.offsetTop;

            this.overlayRef.updateScrollStrategy(this.overlay.scrollStrategies.reposition());

            categorySection.scrollIntoView();
            if (elementTop) {
                window.scroll(0, elementTop - this.HEADER_OFFSET);
            }
        }

        this.dialogRef.close();
    }

    padNumber(num) {
        return num <= 9 ? '0' + num : num;
    }

    ngAfterViewInit(): void {
        const selectCategory = document.getElementsByClassName('category-selected')[0];
        setTimeout(() => {
            selectCategory.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'nearest' });
        }, 400);
    }
}
